import { render } from "./Dashboard.vue?vue&type=template&id=18c09060&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=18c09060&lang=scss&scoped=true"
import "./Dashboard.vue?vue&type=style&index=1&id=18c09060&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1709076162/src/harpia-offshore-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c09060"]])

export default __exports__